import { createContext, ReactNode, useContext, useState } from 'react';

import type { IndeedProject } from 'shared/legacy/hooks/useBrowserExtension/indeed/useIndeedProjectListQuery';

type IndeedCommAgentContextValue = {
  attemptId: number | null;
  setAttemptId: (id: number | null) => void;
  indeedProject: IndeedProject | null;
  setIndeedProject: (p: IndeedProject | null) => void;
};

const IndeedCommAgentContext = createContext<IndeedCommAgentContextValue | null>(null);

type IndeedCommAgentProviderProps = {
  children: ReactNode;
};

export const IndeedCommAgentProvider = ({ children }: IndeedCommAgentProviderProps) => {
  const [attemptId, setAttemptId] = useState<number | null>(null);
  const [indeedProject, setIndeedProject] = useState<IndeedProject | null>(null);

  return (
    <IndeedCommAgentContext.Provider value={{ attemptId, setAttemptId, indeedProject, setIndeedProject }}>
      {children}
    </IndeedCommAgentContext.Provider>
  );
};

export const useIndeedCommAgent = (): IndeedCommAgentContextValue => {
  const ctx = useContext(IndeedCommAgentContext);
  if (!ctx) {
    throw new Error('useIndeedCommAgent must be used within an IndeedCommAgentProvider');
  }
  return ctx;
};
